import { ViewportScroller } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Link } from 'src/app/model/shared/link';
import { SideMenu } from 'src/app/model/shared/side-menu';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ConfigService } from 'src/app/service/config.service';
declare function leftSideIagPortalMenu(): any;

@Component({
  selector: 'app-left-side-menu-iag-portal',
  templateUrl: './left-side-menu-iag-portal.component.html',
  styleUrls: ['./left-side-menu-iag-portal.component.scss']
})
export class LeftSideMenuIagPortalComponent implements OnInit {
  @Input() pageTitle: string = '';

  sideMenu: SideMenu = {} as SideMenu;

  categories: Link[] = [];
  linkMap = new Map();

  constructor(public configService: ConfigService, private scroller: ViewportScroller, private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    this.sideMenu.links = [];
    this.megaSideMenu();
  }

  closeNav() {
    let element: HTMLElement = document.getElementsByClassName('closebtnIAG')[0] as HTMLElement;
    element.click();
  }

  private megaSideMenu() {
    this.sideMenu.links = [];
    const query = { 'fields.name': 'Left Side Menu#IAG-PORTAL' };
    this.contentfulService.getMenuContentWithItems(query).then((menuItems) => {
      this.sideMenu.links = menuItems[0]?.fields.jsonData;
      this.processJSONData();
      leftSideIagPortalMenu();
    });
  }

  processJSONData() {
    this.categories.push(...this.sideMenu.links.filter((link) => link.category === undefined));

    // // console.log(this.categories);

    this.categories.forEach((category) => {
      this.linkMap.set(
        category.title,
        this.sideMenu.links.filter((link) => link.category === category.title)
      );
    });

    // // console.log(this.linkMap);

    if (this.pageTitle === '' || this.pageTitle === undefined) {
      this.pageTitle = this.sideMenu.links[0].pageTitle || '';
    }
  }

  setPageTitle(value: string) {
    // console.log('setPageTitle : ' + value);
    if (value.length > 0) {
      this.pageTitle = value;
    }
  }

  scrollToHref(value: string) {
    // console.log('scrollToHref : ' + value);
    this.scroller.scrollToAnchor(value);
  }

  scrollTotop() {
    window.scrollTo(0, 0);
  }
}
